import type { ReactNode } from 'react';
import './AssetInfoStyle.scss';
export type AssetInfoProps = {
  labelStyle?: string;
  label: string;
  detail?: string;
  amount: string;
  date?: string;
};

export const AssetInfo = (props: AssetInfoProps) => {
  const { labelStyle, label, detail, amount, date } = props;
  return (
    <div className="assetInfo">
      <div className="assetInfo_row">
        <div className="assetInfo_labelGroup">
          <div className={labelStyle ? `assetInfo_label assetInfo_label${labelStyle}` : 'assetInfo_label'}>
            {label}
          </div>
          <div className={labelStyle ? `assetInfo_label assetInfo_label${labelStyle}` : 'assetInfo_label'}>
            {detail}
          </div>
        </div>
        <div className="assetInfo_valueGroup">
          {date && <div className="assetInfo_amount">{date}</div>}
          <div className="assetInfo_amount">{amount === '-' ? '- 円' : `${amount}円`}</div>
        </div>
      </div>
    </div>
  );
};
